export default "__VITE_ASSET__bd5b56b3__"